import React, { Component } from 'react';
import { Button, Collapse } from 'reactstrap';
import './Banner.css';
import PropTypes from 'prop-types';

class Banner extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    toggleGenerateReportModal: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      collapse: false
    };
  }

  render() {
    const notificationCollapseClass = this.state.collapse ? 'togo-icon-flip-vertical' : '';
    const { t } = this.context;
    return (
      <div className="notifyAboutNewReports">
        <div className="placeholder">
          <div className="learnMoreTitle">
            <div className="iconWithTitle">
              <div className="banner-report-icon" />{' '}
              <div className="title">{t('banner.notifyAboutNewReports.title')}</div>
            </div>
            {!this.state.collapse && (
              <div className="learnMoreButton">
                <div className="custom-buttons-chameleon outline-button" onClick={this.toggle}>
                  {t('buttons.learnMore')}
                </div>
              </div>
            )}
          </div>
          <div className="dropdownIcon">
            <i
              className={`togo-icon togo-icon-chevron togo-icon-2x ${notificationCollapseClass}`}
              onClick={this.toggle}
            />
          </div>
        </div>
        <Collapse isOpen={this.state.collapse}>{this.getBannerContent()}</Collapse>
      </div>
    );
  }

  getBannerContent = () => {
    const { t } = this.context;
    const { toggleGenerateReportModal } = this.props;
    return (
      <div>
        <hr />
        <div className="cardContent">
          <div className="column addMargin">
            <p className="title">{t('generateReport.reportType.attendeeV2')}</p>
            <ul>
              <li>{t('generateReport.reportDescription.MultiSessionAttendeeReport1')}</li>
              <li>{t('generateReport.reportDescription.MultiSessionAttendeeReport2')}</li>
            </ul>
          </div>
          <div className="column">
            <p className="title">{t('generateReport.reportType.qandaV2')}</p>
            <ul>
              <li>{t('generateReport.reportDescription.EngagementReport1')}</li>
            </ul>
          </div>
        </div>
        <Button
          id="createReportFromBanner"
          color="primary"
          onClick={() => {
            toggleGenerateReportModal();
            this.toggle();
          }}>
          <div>{t('buttons.buildReport')}</div>
        </Button>
      </div>
    );
  };

  toggle = () => this.setState(prevState => ({ collapse: !prevState.collapse }));
}

export default Banner;



// WEBPACK FOOTER //
// ./src/Components/Banner/Banner.js